<div class="sso-callback-container">
    <div class="loading-message" *ngIf="!displayError">
        <p>Authenticating...</p>
    </div>
    <div class="error-message" *ngIf="displayError">
        <p>Authentication failed. Redirecting to login...</p>
    </div>
</div>
